import { render, staticRenderFns } from "./DialogPromos.vue?vue&type=template&id=64dee8e8"
import script from "./DialogPromos.vue?vue&type=script&lang=js"
export * from "./DialogPromos.vue?vue&type=script&lang=js"
import style0 from "./DialogPromos.vue?vue&type=style&index=0&id=64dee8e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports